import { GRAPHQL_AUTH_MODE, GraphQLQuery } from "@aws-amplify/api"
import { API } from "aws-amplify"
import * as queries from "../../graphql/queries";
import { StartImageGenerationQuery, StartImageGenerationQueryVariables } from "../../API"
import aws_config from "../../modified_aws-export";
import {Auth} from "aws-amplify";

export const startImageGenerationProcess = async (imageId: string, oemTaPair:string, prompt: string, imageGenModel: string) => {
    const currentSession = await Auth.currentSession();
    const currentUserEmail = String(currentSession.getIdToken().payload["email"]);
    const result = await API.graphql<GraphQLQuery<StartImageGenerationQuery>>({
        query: queries.startImageGeneration,
        variables: {
            frontendBucket: aws_config.aws_user_files_s3_bucket,
            backendBucket: aws_config.backend.bucket_name,
            key: "image_similarity_search/" + imageId + ".png",
            oemReferenceKey: "processed_images/" + oemTaPair + ".ai-OEM.png",
            taReferenceKey: "processed_images/" + oemTaPair + ".ai-TA.png",
            prompt: prompt,
            modelName: imageGenModel,
            userMail: currentUserEmail.toLowerCase(),
        } as StartImageGenerationQueryVariables,
        authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
    })
    return result
}